import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import "./fileUpload.css";
import { Button, useToastProvider } from '@deere/fuel-react';
import { useTranslation } from '../translation-context';

const CustomFileInputField = ({ onDropAccepted, uploadFile }) => {
    const [selectedFileName, setSelectedFileName] = useState("");
    const { enqueueToast } = useToastProvider();
    const { translate:t } = useTranslation();

    const handleDroppedFile = (acceptedFiles)=>{
        uploadFile(acceptedFiles[0]);
    }

    const { getRootProps, getInputProps } = useDropzone({
        maxFiles: 1,
        multiple:false,
        accept: {
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
        },
        onDrop: (acceptedFiles) => {
            if(acceptedFiles.length > 1){
                return enqueueToast({
                    variant:"error",
                    message:t("oneFileUpload")
                })
            }
            if(acceptedFiles[0].name.includes("DE") || acceptedFiles[0].name.includes("FR") || acceptedFiles[0].name.includes("UK")){
                setSelectedFileName(acceptedFiles[0].name);
                onDropAccepted(handleDroppedFile(acceptedFiles));
            }else{
                return enqueueToast({
                    variant:"error",
                    message:t("invalidFile")
                })
            }
        },
    });

    return (
        <div className='dropZone' {...getRootProps()} >
            <input {...getInputProps()} />
            {selectedFileName ?
                <p>Selected file: {selectedFileName}</p>
                : <p className='dropArea'>
                    <Button variant='secondary'>Choose  File(s)</Button> <br/>
                    Drag 'n' drop some files here, or click to select files
                </p>
            }
        </div>
    );
};

export default CustomFileInputField;
